module.exports = __webpack_public_path__ + "img/2-low.4e04efcb.jpg";